import React from 'react'
import { IoLogoInstagram } from "react-icons/io5";

import './Instragram.css'

const Instagram = () => {
  return (
    
       <div>
         <div class="instagram">
    <a href="https://www.instagram.com/royalhood.in?igsh=M2Rtd3V2dHl2dzBq" target="_blank">
    <IoLogoInstagram style={{color:"white",fontSize:"30px"}}/><span>Instragram<br/><small></small></span>
    </a>
       </div>
    </div>
    
  )
}

export default Instagram
